import { getData, postData } from '../utils'

// const apiUrlBase = 'http://localhost:9000/api';
// const v1UrlBase = 'http://localhost:9000/v1';
// const apiUrlBase = 'https://dev-mighty-wifi-api.herokuapp.com/api';
// const v1UrlBase = 'https://dev-mighty-wifi-api.herokuapp.com/v1';
const apiUrlBase = 'https://mighty-wifi-api.herokuapp.com/api'
const v1UrlBase = 'https://mighty-wifi-api.herokuapp.com/v1';

const getUserRegisterUrl = () => `${apiUrlBase}/register`
const getLoginUrl = () => `${apiUrlBase}/adminlogin`
const getRentProductUrl = () => `${apiUrlBase}/product/rent`
const getAddCartUrl = () => `${apiUrlBase}/add/cart`
const getCartUrl = () => `${apiUrlBase}/cart`
const getplaceOrderUrl = () => `${apiUrlBase}/place/order`
const getordersUrl = () => `${apiUrlBase}/get/orders`
const getSingleOrderUrl = orderId => `${apiUrlBase}/get/order/${orderId}`
const getUpdateUserUrl = () => `${apiUrlBase}/update/profile`
const getUserUrl = () => `${apiUrlBase}/user`

const getAddShippingUrl = () => `${apiUrlBase}/add/shipping`
const getUpdatedShippingUrl = id => `${apiUrlBase}/update/shipping/${id}`

/*______________________________________________________________________*/
//const getCustomersListUrl = id => `${apiUrlBase}/users/`
const getCustomersListUrl = (page, limit, column, sortDir, searchText) => `${apiUrlBase}/users?page=${page}&limit=${limit}&column=${column}&sortDir=${sortDir}&searchText=${searchText}`
const getCustomerDetailUrl = id => `${apiUrlBase}/user/${id}`
const getOrderTypeOfUrl = (type, page, limit, column, sortDir, searchText) => `${apiUrlBase}/get/ordertype/${type}?page=${page}&limit=${limit}&column=${column}&sortDir=${sortDir}&searchText=${searchText}`
const updateOrderUrl = () => `${apiUrlBase}/order/update`
const getStoreAddressUrl = () => `${apiUrlBase}/get/store/addresses`

const getDeviceInventoryUrl = () => `${apiUrlBase}/device/inventory`
const updateDeviceInventoryUrl = () => `${apiUrlBase}/device/inventory/update`
const addDeviceInventoryUrl = () => `${apiUrlBase}/device/inventory`
const bulkDeviceInventoryUrl = () => `${apiUrlBase}/device/inventory/bulk`

const getSimInventoryUrl = () => `${apiUrlBase}/sim/inventory`
const updateSimInventoryUrl = () => `${apiUrlBase}/sim/inventory/update`
const addSimInventoryUrl = () => `${apiUrlBase}/sim/inventory`
const bulkSimInventoryUrl = () => `${apiUrlBase}/sim/inventory/bulk`

const getActiveLinesInventoryUrl = () => `${apiUrlBase}/activelines/inventory`
const updateActiveLinesInventoryUrl = () => `${apiUrlBase}/activelines/inventory/update`
const addActiveLinesInventoryUrl = () => `${apiUrlBase}/activelines/inventory`
const bulkActiveLinesInventoryUrl = () => `${apiUrlBase}/activelines/inventory/bulk`

const sendExpirationNotificationUrl = () => `${apiUrlBase}/expiration/email/send`

const getAmazonOrdersCallURL = () => `${apiUrlBase}/amazon/orders`
const getDeviceActivateRequestsCallURL = () => `${apiUrlBase}/device/active/requests`
const getSimActivateRequestsCallURL = () => `${apiUrlBase}/sim/active/requests`
const getProductsByTypeUrl = type => `${apiUrlBase}/products/${type}`
const getCategoriesURL = () => `${apiUrlBase}/categories`
const getRecurringProfileURL = () => `${apiUrlBase}/recurring/profiles`
const getOptionsURL = () => `${apiUrlBase}/options`

const addCategoryURL = () => `${apiUrlBase}/add/category`
const addOptionURL = () => `${apiUrlBase}/add/option`
const addRecurringURL = () => `${apiUrlBase}/add/recurring/profile`
const editCategoryURL = () => `${apiUrlBase}/update/category`
const editOptionURL = () => `${apiUrlBase}/update/option`
const editRecurringURL = () => `${apiUrlBase}/update/recurring/profile`
const getAllProductsUrl = () => `${apiUrlBase}/products`

const addProductURL = () => `${apiUrlBase}/add/product`
const editProductURL = () => `${apiUrlBase}/update/product`

const editDiscountURL = () => `${apiUrlBase}/update/discount`
const addDiscountURL = () => `${apiUrlBase}/add/discount`
const getDiscountURL = () => `${apiUrlBase}/list/discounts`

const deleteProductCallURL = () => `${apiUrlBase}/delete/product`
const deleteRecurringProfileURL = () => `${apiUrlBase}/delete/recurring/profile`
const deleteOptionCallURL = () => `${apiUrlBase}/delete/option`
const deleteCategoryCallURL = () => `${apiUrlBase}/delete/category`
const deleteDiscountCallURL = () => `${apiUrlBase}/delete/discount`
const changeStatusURL = () => `${apiUrlBase}/product/status/update`

const getApiOrderTypeOfUrl = (type, page, limit, column, sortDir, searchText) => `${v1UrlBase}/get/ordertype/${type}?page=${page}&limit=${limit}&column=${column}&sortDir=${sortDir}&searchText=${searchText}`
const updateApiOrderUrl = () => `${v1UrlBase}/order/update`

const getAutoRenewalsCallURL = (type, page, limit, column, sortDir, searchText) => `${apiUrlBase}/get/autorenewal/${type}?page=${page}&limit=${limit}&column=${column}&sortDir=${sortDir}&searchText=${searchText}`
const getAutoRenewalOrdersCallURL = (profileId, page, limit, column, sortDir, searchText) => `${apiUrlBase}/get/autorenewal/order/${profileId}?page=${page}&limit=${limit}&column=${column}&sortDir=${sortDir}&searchText=${searchText}`
const cancelAutoRenewalCallURL = () => `${apiUrlBase}/autorenewal/cancel`
const updateAutoRenewalCallURL = () => `${apiUrlBase}/autorenewal/update`

async function changeStatusCall(payload){
  const url = changeStatusURL();
  return await postData(url, payload)
}

async function deleteDiscountCall(payload) {
  const url = deleteDiscountCallURL()
  return await postData(url, payload)
}

async function deleteProductCall(payload) {
  const url = deleteProductCallURL()
  return await postData(url, payload)
}

async function deleteCategoryCall(payload) {
  const url = deleteCategoryCallURL()
  return await postData(url, payload)
}

async function deleteRecurringProfileCall(payload) {
  const url = deleteRecurringProfileURL()
  return await postData(url, payload)
}

async function deleteOptionCall(payload) {
  const url = deleteOptionCallURL()
  return await postData(url, payload)
}

async function editDiscountCall(payload) {
  const url = editDiscountURL()
  return await postData(url, payload)
}

async function addDiscountCall(payload) {
  const url = addDiscountURL()
  return await postData(url, payload)
}

async function getDiscountsCall() {
  const url = getDiscountURL()
  return await getData(url)
}

async function editProductCall(payload) {
  const url = editProductURL()
  return await postData(url, payload)
}

async function addProductCall(payload) {
  const url = addProductURL()
  return await postData(url, payload)
}

async function getProductsCall() {
  const url = getAllProductsUrl()
  return await getData(url)
}

async function addCategoryCall(payload) {
  const url = addCategoryURL()
  return await postData(url, payload)
}

async function addOptionCall(payload) {
  const url = addOptionURL()
  return await postData(url, payload)
}

async function addRecurringCall(payload) {
  const url = addRecurringURL()
  return await postData(url, payload)
}

async function editCategoryCall(payload) {
  const url = editCategoryURL()
  return await postData(url, payload)
}

async function editOptionCall(payload) {
  const url = editOptionURL()
  return await postData(url, payload)
}

async function editRecurringCall(payload) {
  const url = editRecurringURL()
  return await postData(url, payload)
}

async function getCategoriesCall() {
  const url = getCategoriesURL()
  return await getData(url)
}

async function getRecurringProfileCall() {
  const url = getRecurringProfileURL()
  return await getData(url)
}

async function getOptionsCall() {
  const url = getOptionsURL()
  return await getData(url)
}

async function getProductsByType(type) {
  const url = getProductsByTypeUrl(type)
  return await getData(url)
}

async function getAmazonOrdersCall() {
  const url = getAmazonOrdersCallURL()
  return await getData(url)
}

async function getDeviceActivateRequestsCall() {
  const url = getDeviceActivateRequestsCallURL()
  return await getData(url)
}

async function getSimActivateRequestsCall() {
  const url = getSimActivateRequestsCallURL()
  return await getData(url)
}

async function notifyExpirationCall(payload) {
  const url = sendExpirationNotificationUrl()
  return await postData(url, payload)
}

async function getActiveLinesInventoryCall() {
  const url = getActiveLinesInventoryUrl()
  return await getData(url)
}

async function addActiveLine(payload) {
  const url = addActiveLinesInventoryUrl()
  return await postData(url, payload)
}

async function updateActiveLine(payload) {
  const url = updateActiveLinesInventoryUrl()
  return await postData(url, payload)
}

async function bulkUpdateActiveLineCall(payload) {
  const url = bulkActiveLinesInventoryUrl()
  return await postData(url, payload)
}

async function updateSim(payload) {
  const url = updateSimInventoryUrl()
  return await postData(url, payload)
}

async function updateDevice(payload) {
  const url = updateDeviceInventoryUrl()
  return await postData(url, payload)
}

async function getSimInventoryCall() {
  const url = getSimInventoryUrl()
  return await getData(url)
}

async function bulkUpdateSimCall(reqPayload) {
  const url = bulkSimInventoryUrl()
  return await postData(url, reqPayload)
}

async function addSim(reqPayload) {
  const url = addSimInventoryUrl()
  return await postData(url, reqPayload)
}

async function bulkUpdateDeviceCall(reqPayload) {
  const url = bulkDeviceInventoryUrl()
  return await postData(url, reqPayload)
}

async function addDevice(reqPayload) {
  const url = addDeviceInventoryUrl()
  return await postData(url, reqPayload)
}

async function getDeviceInventoryCall() {
  const url = getDeviceInventoryUrl()
  return await getData(url)
}

async function getStoreAddress() {
  const url = getStoreAddressUrl()
  return await getData(url)
}

async function rentProduct() {
  const url = getRentProductUrl()
  return await getData(url)
}

async function getOrdersCall() {
  const url = getordersUrl()
  return await getData(url)
}

async function getSingleOrderCall(orderId) {
  const url = getSingleOrderUrl(orderId)
  return await getData(url)
}

async function getLoggedInUser() {
  const url = getUserUrl()
  return await getData(url)
}

async function getCartCall(reqPayload) {
  const url = getCartUrl()
  return await postData(url, reqPayload)
}

// Post Calls
async function registerUser(reqPayload) {
  const url = getUserRegisterUrl()
  return await postData(url, reqPayload)
}
async function loginUser(reqPayload) {
  const url = getLoginUrl()
  return await postData(url, reqPayload)
}

async function addIntoCart(reqPayload) {
  const url = getAddCartUrl()
  return await postData(url, reqPayload)
}

async function placeOrderCall(reqPayload) {
  const url = getplaceOrderUrl()
  return await postData(url, reqPayload)
}

async function updateUser(reqPayload) {
  const url = getUpdateUserUrl()
  return await postData(url, reqPayload)
}

//Shipping Calls

async function updateShippingRequest(reqPayload) {
  const url = getAddShippingUrl()
  return await postData(url, reqPayload)
}

async function addShippingRequest(reqPayload) {
  const url = getUpdatedShippingUrl()
  return await postData(url, reqPayload)
}

/****** Admin dashboard calls ******/

/*async function getAllCustomersRequest() {
  const url = getCustomersListUrl()
  return await getData(url)
}*/
async function getAllCustomersRequest(page, limit, column, sortDir, searchText) {
  const url = getCustomersListUrl(page, limit, column, sortDir, searchText)
  return await getData(url)
}

async function getCustomerDetailRequest(userId) {
  const url = getCustomerDetailUrl(userId)
  return await getData(url)
}

async function getOrderTypeOfRequest(type, page, limit, column, sortDir, searchText) {
  const url = getOrderTypeOfUrl(type, page, limit, column, sortDir, searchText)
  return await getData(url)
}

async function updateOrderRequest(reqPayload) {
  const url = updateOrderUrl()
  return await postData(url, reqPayload)
}

async function getApiOrderTypeOfRequest(type, page, limit, column, sortDir, searchText) {
  const url = getApiOrderTypeOfUrl(type, page, limit, column, sortDir, searchText)
  return await getData(url)
}

async function updateApiOrderRequest(reqPayload) {
  const url = updateApiOrderUrl()
  return await postData(url, reqPayload)
}

async function getAutoRenewalsCall(type, page, limit, column, sortDir, searchText) {
  const url = getAutoRenewalsCallURL(type, page, limit, column, sortDir, searchText)
  return await getData(url)
}

async function getAutoRenewalOrdersCall(profileId, page, limit, column, sortDir, searchText) {
  const url = getAutoRenewalOrdersCallURL(profileId, page, limit, column, sortDir, searchText)
  return await getData(url)
}

async function cancelAutoRenewalCall(reqPayload) {
  const url = cancelAutoRenewalCallURL()
  return await postData(url, reqPayload)
}

async function updateAutoRenewalCall(reqPayload) {
  const url = updateAutoRenewalCallURL()
  return await postData(url, reqPayload)
}

/****** Admin dashboard calls ended ******/

export {
  rentProduct,
  registerUser,
  loginUser,
  addIntoCart,
  getCartCall,
  placeOrderCall,
  getOrdersCall,
  getSingleOrderCall,
  updateUser,
  getLoggedInUser,
  updateShippingRequest,
  addShippingRequest,
  getAllCustomersRequest,
  getCustomerDetailRequest,
  getOrderTypeOfRequest,
  updateOrderRequest,
  getStoreAddress,
  getDeviceInventoryCall,
  addDevice,
  bulkUpdateDeviceCall,
  getSimInventoryCall,
  addSim,
  bulkUpdateSimCall,
  updateSim,
  updateDevice,
  getActiveLinesInventoryCall,
  addActiveLine,
  updateActiveLine,
  bulkUpdateActiveLineCall,
  notifyExpirationCall,
  getAmazonOrdersCall,
  getDeviceActivateRequestsCall,
  getSimActivateRequestsCall,
  getProductsByType,
  getCategoriesCall,
  getRecurringProfileCall,
  getOptionsCall,
  addCategoryCall,
  addOptionCall,
  addRecurringCall,
  editCategoryCall,
  editOptionCall,
  editRecurringCall,
  getProductsCall,
  addProductCall,
  editProductCall,
  editDiscountCall,
  addDiscountCall,
  getDiscountsCall,
  deleteProductCall,
  deleteRecurringProfileCall,
  deleteOptionCall,
  deleteCategoryCall,
  deleteDiscountCall,
  changeStatusCall,
  getApiOrderTypeOfRequest,
  updateApiOrderRequest,
  getAutoRenewalsCall,
  getAutoRenewalOrdersCall,
  cancelAutoRenewalCall,
  updateAutoRenewalCall
}



// WEBPACK FOOTER //
// ./src/ducks/services/mightyWifiApi.js